import populateSkeletons from './populate_skeletons'

export default function (collection, opts) {
  populateSkeletons(collection, {}, 5, {
    add: true,
    at: collection.length
  })

  collection.fetch(opts)
}
